import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';

const entertainments: AppRouteModule = {
    path: '/entertainments',
    name: PageEnum.ENTERTAINMENTS,
    component: LAYOUT,
    redirect: '/entertainments/index',
    meta: {
        orderNo: 15,
        icon: 'championships',
        title: '战力赛',
        /** 是否有等级分限制 */
        scoreLimit: !false,
        /** 赛事类型 1：锦标赛，2：战力赛 */
        type: 2,
        /** 大厅页 */
        homePageName: 'EntertainmentIndex',
        /** 赛事详情页 */
        detailsPageName: PageEnum.ENTERTAINMENT_DETAILS,
        /** 游戏页 */
        gamePageName: PageEnum.ENTERTAINMENT_GAME,
    },
    children: [
        {
            path: 'index',
            name: 'EntertainmentIndex',
            component: () => import('@/views/menu/championships/index.vue'),
            meta: {
                title: '战力赛',
            },
        },
        {
            path: 'details',
            name: PageEnum.ENTERTAINMENT_DETAILS,
            component: () => import('@/views/menu/championships/competition-details/index.vue'),
            meta: {
                title: '战力赛',
            },
        },
        {
            path: 'game',
            name: PageEnum.ENTERTAINMENT_GAME,
            component: () => import('@/views/menu/championships/game/index.vue'),
            meta: {
                title: '战力赛',
            },
        },
    ],
};

export default entertainments;
